import { ButtonConfig, ButtonType } from './buttonTypes';

export const BUTTON_TYPES: Record<ButtonType, ButtonConfig> = {
    save: {
        className: 'btn-success',
        icon: 'ri-check-line',
        text: '저장',
    },
    delete: {
        className: 'btn-danger',
        icon: 'ri-delete-bin-line',
        text: '삭제',
    },
    cancel: {
        className: 'btn-primary',
        icon: 'ri-close-line',
        text: '취소',
    },
    edit: {
        className: 'btn-warning',
        icon: 'ri-edit-line',
        text: '수정',
    },
    add: {
        className: 'btn-info',
        icon: 'ri-add-line',
        text: '추가',
    },
};
